import styled from "styled-components";
import { hardSkills, softSkills } from "../../data";

const Skills = ({ t }) => {
  return (
    <StyledWrapper className="wrapper">
      <StyledContent className="content" id="umiejetnosci">
        <h1> {t("umiejetnosci")}</h1>

        <div className="blocks-container">
          <StyledBlocks className="blocks">
            <h1>SOFT</h1>
            {softSkills.map((skill, index) =>
              skill?.name ? (
                <StyledScene
                  key={skill.name}
                  className="scene"
                  style={{ zIndex: Math.round(99999 - (index * 10) / 2) }}
                >
                  <div
                    className="cube"
                    style={{
                      animation: `rotate-right 180s infinite ${
                        index / 1
                      }s  linear `,
                    }}
                  >
                    <div className="side front">{t(skill.name)}</div>
                    <div className="side back">{t(skill.name)}</div>
                    <div className="side left">{t(skill.name)}</div>
                    <div className="side right">{t(skill.name)}</div>
                    <div className="side top"></div>
                    <div className="side bottom"></div>
                  </div>
                </StyledScene>
              ) : null
            )}
          </StyledBlocks>
          <StyledBlocks className="blocks">
            <h1>HARD</h1>
            {hardSkills.map((skill, index) => (
              <StyledScene
                key={skill.name}
                className="scene"
                style={{ zIndex: Math.round(99999 - (index * 10) / 2) }}
              >
                <div
                  className="cube"
                  style={{
                    animation: `rotate-right 180s infinite ${
                      index / 1
                    }s  linear `,
                  }}
                >
                  <div className="side front">{skill.name}</div>
                  <div className="side back">{skill.name}</div>
                  <div className="side left">{skill.name}</div>
                  <div className="side right">{skill.name}</div>
                  <div className="side top"></div>
                  <div className="side bottom"></div>
                </div>
              </StyledScene>
            ))}
          </StyledBlocks>
        </div>
      </StyledContent>
    </StyledWrapper>
  );
};

export default Skills;

const StyledScene = styled.div`
  margin: 8px 0;
  transform-style: preserve-3d;
  width: 20rem;
  height: 3rem;
  perspective: 101230px;
  perspective-origin: 50% -50000%;
  position: relative;

  .cube {
    z-index: 10000;
    transform-style: preserve-3d;
    position: relative;
    width: 20rem;
    height: 3rem;
    transition: margin 0.2s ease-in-out;
  }

  .side {
    text-transform: uppercase;
    width: 20rem;
    height: 3rem;
    position: absolute;
    font-size: 2em;
    padding: 5px;
    background-color: #d7d6d5;
    border: 1px solid #483a37;
    color: #101010;
  }

  .front {
    transform: translateZ(10rem);
  }

  .back {
    transform: rotateY(180deg) translateZ(10rem);
  }

  .right {
    transform: rotateY(90deg) translateZ(10rem);
  }

  .left {
    transform: rotateY(-90deg) translateZ(10rem);
  }

  .top {
    position: absolute;
    height: 675%;
    background-color: #483a37;
    transform: rotateX(90deg) translateZ(10.1rem);
  }

  .bottom {
    position: absolute;
    transform: rotateX(-90deg) translateZ(1.5rem);
  }

  @keyframes rotate-right {
    0% {
      transform: rotateY(0deg) rotateX(0deg) rotateZ(0deg);
    }

    100% {
      transform: rotateY(360deg) rotateX(0deg) rotateZ(0deg);
    }
  }
  @keyframes rotate-left {
    0% {
      transform: rotateY(0deg) rotateX(0deg) rotateZ(0deg);
    }

    100% {
      transform: rotateY(-360deg) rotateX(0deg) rotateZ(0deg);
    }
  }
`;

const StyledWrapper = styled.div``;

const StyledBlocks = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 30px;
  margin-bottom: 50px;

  h1 {
    font-size: 2.8rem;
    letter-spacing: 3px;
    margin-bottom: 50px;
    text-align: center;
    
  }
`;

const StyledContent = styled.div`
  h1 {
    text-transform: uppercase;
  }

  .blocks-container {
    display: flex;
    justify-content: space-evenly;

    @media (max-width: 1200px) {
      flex-direction: column;
      align-items: center;
      font-size: 0.9rem !important;
    }
  }
`;
